import { render, staticRenderFns } from "./yuanLiaoDetalis.vue?vue&type=template&id=337ec0f8&scoped=true&"
import script from "./yuanLiaoDetalis.vue?vue&type=script&lang=js&"
export * from "./yuanLiaoDetalis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337ec0f8",
  null
  
)

export default component.exports